export default __webpack_public_path__ + "static/media/its_electric_icon.9818d586.svg";